var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import ReactDOM from 'react-dom';
import React from 'react';
import * as videojs from 'video.js';
import { Provider } from 'react-redux';
import store from 'src/store';
import VideoSwitch from './VideoSwitch';
var BaseComponent = videojs.getComponent('Component');
var VideoPlayerSwitchContainer = /** @class */ (function (_super) {
    __extends(VideoPlayerSwitchContainer, _super);
    function VideoPlayerSwitchContainer(player, options) {
        var _this = _super.call(this, player, options) || this;
        _this.mountReactComponent = _this.mountReactComponent.bind(_this);
        player.ready(function () { return _this.mountReactComponent(); });
        return _this;
    }
    VideoPlayerSwitchContainer.prototype.mountReactComponent = function () {
        ReactDOM.render(React.createElement(Provider, { store: store },
            React.createElement(VideoSwitch, null)), this.el());
    };
    return VideoPlayerSwitchContainer;
}(BaseComponent));
export default VideoPlayerSwitchContainer;



//////////////////
// WEBPACK FOOTER
// ./src/components/reusable/video/VideoPlayerSwitchContainer.tsx
// module id = 794
// module chunks = 81